import store from "@/shared/store";
import {Trans} from "@/shared/scripts/helpers/translation/translation";

declare global {
    interface Window {
        hj?: (
            command: "identify",
            userId: string | null,
            attributes: Record<string, string | number | boolean>
        ) => void;
    }
}

export function pushHotjarQRDetails(retries = 3, delay = 500): void {
    const user = store.getters["UserModule/getUser"] || null;
    if (!user?.id) {
        return;
    }

    const postalCode: string = store.getters["FormModule/getValue"]("property.location.address.postalCode");
    const province: string | null = getValidProvinceForQRBilboards(postalCode);
    const localEnvironment: string = process.env.VUE_APP_ENVIRONMENT_NAME || "local";
    const isNonProdEnv: boolean = ["local", "dev", "test"].includes(localEnvironment);

    if (!province) {
        if (isNonProdEnv) {
            console.debug("[Hotjar] Province is not valid for QR Billboards. Postal Code:", postalCode);
        }
        return;
    }

    const attributes = {
        Province: province,
        ListingId: store.getters["FormModule/getClassifiedId"] || "unknown",
        ListingType: store.getters["FormModule/getValue"]("property.type") || "unknown",
        OwnerType: "PRIVATE",
        Language: Trans.currentLocale || "unknown",
        InSelectedProvince: "Yes",
    };

    // Retry up to 3 times because Hotjar loads slowly
    if (typeof window.hj === "function") {
        if (isNonProdEnv) {
            console.debug("[Hotjar] Preparing to push details for user:", user.id, "with attributes:", attributes);
        }

        window.hj("identify", user.id, attributes);
    } else if (retries > 0) {
        if (isNonProdEnv) {
            console.debug(`[Hotjar] Library is not ready. Retrying in ${delay}ms... (retries left: ${retries})`);
        }

        setTimeout(() => {
            pushHotjarQRDetails(retries - 1, delay * 2);
        }, delay);
    } else {
        if (isNonProdEnv) {
            console.warn("[Hotjar] Failed to load library after 3 attempts.");
        }
    }
}

export function getValidProvinceForQRBilboards(zip: string): string | null {
    const code = parseInt(zip, 10);

    if (code >= 2000 && code <= 2999) return "Antwerp";
    if (code >= 1000 && code <= 1299) return "Brussels";
    if (code >= 3500 && code <= 3999) return "Limburg";
    if (code >= 4000 && code <= 4999) return "Liège";
    if (code >= 5000 && code <= 5999) return "Namur";

    return null;
}
